var _rect, _g, _rect2, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFmv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_10772_13929",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "current"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_10772_13929)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_10772_13929",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -1,
    y: 0,
    width: 25,
    height: 25
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -0.103516,
    y: 0.761719,
    width: 24,
    height: 24,
    fill: "current"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_10772_13929)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.75 21V19H4.80775C4.30258 19 3.875 18.825 3.525 18.475C3.175 18.125 3 17.6974 3 17.1923V5.80775C3 5.30258 3.175 4.875 3.525 4.525C3.875 4.175 4.30258 4 4.80775 4H20.1923C20.6974 4 21.125 4.175 21.475 4.525C21.825 4.875 22 5.30258 22 5.80775V7.6155H20.5V5.80775C20.5 5.71792 20.4712 5.64417 20.4135 5.5865C20.3558 5.52883 20.2821 5.5 20.1923 5.5H4.80775C4.71792 5.5 4.64417 5.52883 4.5865 5.5865C4.52883 5.64417 4.5 5.71792 4.5 5.80775V17.1923C4.5 17.2821 4.52883 17.3558 4.5865 17.4135C4.64417 17.4712 4.71792 17.5 4.80775 17.5H11.6923V21H8.75ZM15.6693 16.8462C15.6693 16.2441 15.8815 15.7307 16.306 15.306C16.7307 14.8815 17.2441 14.6692 17.8462 14.6692C18.4482 14.6692 18.9616 14.8815 19.3863 15.306C19.8108 15.7307 20.023 16.2441 20.023 16.8462C20.023 17.4482 19.8108 17.9616 19.3863 18.3863C18.9616 18.8108 18.4482 19.023 17.8462 19.023C17.2441 19.023 16.7307 18.8108 16.306 18.3863C15.8815 17.9616 15.6693 17.4482 15.6693 16.8462ZM21.0805 9C21.3422 9 21.5608 9.0885 21.7365 9.2655C21.9122 9.4425 22 9.66183 22 9.9235V20.0805C22 20.3422 21.9115 20.5608 21.7345 20.7365C21.5575 20.9122 21.3382 21 21.0765 21H14.6117C14.3501 21 14.1314 20.9115 13.9557 20.7345C13.7801 20.5575 13.6923 20.3382 13.6923 20.0765V9.9195C13.6923 9.65783 13.7808 9.43917 13.9578 9.2635C14.1348 9.08783 14.3541 9 14.6158 9H21.0805ZM17.8447 9.923C17.4444 9.923 17.1138 10.0539 16.853 10.3158C16.592 10.5776 16.4615 10.9087 16.4615 11.309C16.4615 11.7095 16.5924 12.0402 16.8542 12.301C17.1161 12.5618 17.4472 12.6923 17.8475 12.6923C18.2478 12.6923 18.5785 12.5614 18.8395 12.2998C19.1003 12.0379 19.2307 11.7067 19.2307 11.3063C19.2307 10.9059 19.0998 10.5753 18.838 10.3145C18.5763 10.0535 18.2452 9.923 17.8447 9.923ZM17.8447 20.077C18.7521 20.077 19.5176 19.7656 20.1413 19.1428C20.7651 18.5199 21.077 17.7548 21.077 16.8475C21.077 15.9402 20.7656 15.1747 20.1428 14.551C19.5199 13.9273 18.7548 13.6155 17.8475 13.6155C16.9402 13.6155 16.1747 13.9268 15.551 14.5495C14.9273 15.1723 14.6155 15.9374 14.6155 16.8448C14.6155 17.7521 14.9268 18.5176 15.5495 19.1413C16.1723 19.7651 16.9374 20.077 17.8447 20.077Z",
    fill: "current"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFmv);
export default __webpack_public_path__ + "static/media/fmv.497a8e7fdbf41abccbfa27d1b9fe801f.svg";
export { ForwardRef as ReactComponent };